// All user related database operations can be defined here.
import axios from "axios";
import { REGISTER_WITH, SYSTEM_ERROR } from "config/CONSTANTS";
import { axiosGet, axiosPut } from "./ajaxServices";
import {
  urlUserLogin,
} from "./CONSTANTS";

export const apiLogin = (userDetail) => {
  const { register_with, email, phone, password } = userDetail;
  const url = urlUserLogin;
  let param = { password: password, register_with: register_with };
  if (register_with === REGISTER_WITH.email) {
    param["email"] = email;
  } else {
    param["phone"] = phone;
  }

  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };
  var param_data = new FormData();
  param_data.append("email", param.email)
  param_data.append("password", param.password)

  return new Promise((resolve, reject) => {
    try {
      // do an SDK, DB call or API endpoint axios call here and return the promise.
      axios
        .post(url, param_data, config)
        .then((res) => {
          const { data } = res;
          if (data.status === true) {
            resolve(data.data);
          } else {
            reject(data.message);
          }
        })
        .catch((err) => {
          reject("Error in getUserDetails axios!");
        });
    } catch (error) {
      console.error("in userServices > apiLogin, Err===", error);
      reject(SYSTEM_ERROR);
    }
  });
};

